module.exports = __webpack_public_path__ + "static/media/openTickets.a50ccbb5.svg";